// Angular
import { Component, ElementRef, Input, OnInit, ViewChild, SimpleChanges, OnChanges, DoCheck, ChangeDetectionStrategy } from '@angular/core';
// Layout config
import { LayoutConfigService } from '../../../../../core/_base/layout';
import { plugins } from 'chartist';

/**
 * Sample components with sample data
 */
@Component({
	selector: 'kt-widget12',
	templateUrl: './widget12.component.html',
	styleUrls: ['./widget12.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class Widget12Component implements OnInit, OnChanges, DoCheck {

	// Public properties
	@Input() data: { labels: string[], datasets: any[] };
	@Input() type = 'line';
	@ViewChild('chart', {static: true}) chart: ElementRef;
	chartData: any;

	/**
	 * Component constructor
	 * @param layoutConfigService
	 */
	constructor(private layoutConfigService: LayoutConfigService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		if (!this.data) {
			const color = Chart.helpers.color;
			this.data = {
				labels: ['1 Jan', '2 Jan', '3 Jan', '4 Jan', '5 Jan', '6 Jan', '7 Jan'],
				datasets: [
					{
						fill: true,
						// borderWidth: 0,
						backgroundColor: color(this.layoutConfigService.getConfig('colors.state.brand')).alpha(0.6).rgbString(),
						borderColor: color(this.layoutConfigService.getConfig('colors.state.brand')).alpha(0).rgbString(),

						pointHoverRadius: 4,
						pointHoverBorderWidth: 12,
						pointBackgroundColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
						pointBorderColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
						pointHoverBackgroundColor: this.layoutConfigService.getConfig('colors.state.brand'),
						pointHoverBorderColor: Chart.helpers.color('#000000').alpha(0.1).rgbString(),

						data: [20, 40, 50, 25, 35, 60, 30]
					},
					{
						fill: true,
						// borderWidth: 0,
						backgroundColor: color(this.layoutConfigService.getConfig('colors.state.brand')).alpha(0.2).rgbString(),
						borderColor: color(this.layoutConfigService.getConfig('colors.state.brand')).alpha(0).rgbString(),

						pointHoverRadius: 4,
						pointHoverBorderWidth: 12,
						pointBackgroundColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
						pointBorderColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
						pointHoverBackgroundColor: this.layoutConfigService.getConfig('colors.state.brand'),
						pointHoverBorderColor: Chart.helpers.color('#000000').alpha(0.1).rgbString(),

						data: [25, 45, 55, 30, 40, 65, 35]
					}
				]
			};
		}
		this.chartData = new Chart(this.chart.nativeElement, {});
	}
	ngOnChanges(changes: SimpleChanges): void{
		setTimeout(() => {
		this.initChart();
		}, 3000);
		
	}
	ngDoCheck() {
		setTimeout(() => {
		this.chartData.update()
		}, 2000);
	  }
	private initChart() {
		// For more information about the chartjs, visit this link
		// https://www.chartjs.org/docs/latest/getting-started/usage.html
		// var max = this.data.datasets[0].data.reduce(function(a, b) {
		// 	return Math.max(a, b);
		// });
		this.chartData = new Chart(this.chart.nativeElement, {
			type: this.type,
			data: this.data,
			options: {
				animation: {
					duration: 0
				},
				hover: {
					animationDuration: 0
				},
				responsiveAnimationDuration: 0,
				responsive: true,
				maintainAspectRatio: false,
				legend:  {
					display: true,
					position: 'top',
					align:'end',
					labels: {
						fontColor: '#000'
					}
				},
				scales: {
					xAxes: [{
						categoryPercentage: 0.35,
						barPercentage: 0.70,
						display: true,
						scaleLabel: {
							display: false,
							labelString: 'Month'
						},
						gridLines: false,
						ticks: {
							display: true,
							beginAtZero: true,
							fontColor: this.layoutConfigService.getConfig('colors.base.shape.3'),
							fontSize: 13,
							padding: 10
						}
					}],
					yAxes: [{
						categoryPercentage: 0.35,
						barPercentage: 0.70,
						display: true,
						scaleLabel: {
							display: false,
							labelString: 'Value'
						},
						gridLines: {
							// color: this.layoutConfigService.getConfig('colors.base.shape.2'),
							// drawBorder: false,
							// offsetGridLines: false,
							// drawTicks: false,
							// borderDash: [3, 4],
							// zeroLineWidth: 1,
							// zeroLineColor: this.layoutConfigService.getConfig('colors.base.shape.2'),
							// zeroLineBorderDash: [3, 4]
						},
						ticks: {
							// max: this.data.maximumValue + 10,
							// stepSize: this.data.maximumValue/10,
							display: true,
							beginAtZero: true,
							fontColor: this.layoutConfigService.getConfig('colors.base.shape.3'),
							fontSize: 13,
							padding: 10
						}
					}]
				},
				title: {
					display: false
				},
				// hover: {
				// 	mode: 'index'
				// },
				tooltips: {
					enabled: true,
					intersect: false,
					mode: 'nearest',
					bodySpacing: 5,
					yPadding: 10,
					xPadding: 10,
					caretPadding: 0,
					displayColors: false,
					backgroundColor: this.layoutConfigService.getConfig('colors.state.brand'),
					titleFontColor: '#ffffff',
					cornerRadius: 4,
					footerSpacing: 0,
					titleSpacing: 0
				},
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 5,
						bottom: 5
					}
				}
			},
			plugins: [{
                beforeInit: function(chart, options) {
                  chart.legend.afterFit = function() {
                    this.height = this.height + 30;
                  };
                }
              }]
		});
		var myChart = new Chart(this.chart.nativeElement);

		this.chart.nativeElement.onclick = function(evt) {
		// var activePoint = this.getElementAtEvent(evt)[0];
		// var data = activePoint._chart.data;
		// var datasetIndex = activePoint._datasetIndex;
		// var label = data.datasets[datasetIndex].label;
		// var value = data.datasets[datasetIndex].data[activePoint._index];
		// alert('chsth')
		}
	}

}
